import React, {forwardRef, FC} from "react";
import {Alert, Checkbox, Form} from "antd";
import {privacyConsentRules} from "./formRules";
import {useRegistrationCopy} from "./registrationCopy";

export const PrivacyConsentField: FC = () => {
    const {labels} = useRegistrationCopy();

    return (
        <Form.Item
            name="gdprConsentAccepted"
            valuePropName="checked"
            rules={privacyConsentRules(labels)}
            className="public-registration-consent"
        >
            <Checkbox>{labels.privacyConsent}</Checkbox>
        </Form.Item>
    );
};

// Focusable wrapper so a failed submit can move focus to the explanation.
export const SubmitErrorAlert = forwardRef<HTMLDivElement, {message: string | null}>(({message}, ref) => {
    const {labels} = useRegistrationCopy();

    if (!message) {
        return null;
    }

    return (
        <div ref={ref} tabIndex={-1} role="alert">
            <Alert
                role="presentation"
                type="error"
                showIcon
                message={labels.submitFailedTitle}
                description={message}
            />
        </div>
    );
});
SubmitErrorAlert.displayName = "SubmitErrorAlert";
